import { useEffect } from 'react';
import CiudadForm from '../../components/ciudades/CiudadForm';
import { useCiudadesStore, type RegistrarCiudad } from '../../stores/ciudades/ciudades.store';

const AgregarCiudad = () => {
  const { current: ciudad, nuevo, registrar } = useCiudadesStore();

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarCiudad) => {
    return registrar(values);
  };

  return <CiudadForm esAgregar={true} ciudad={ciudad} onSave={handleSave} />;
};

export default AgregarCiudad;
